import { html, LitEntity } from '../../utility/lit-entity';
import './mtech-protein-integration-modal';
import { IntegrationOverviewMixin } from './integration-overview-mixin';

class MtechProteinIntegrationOverview extends IntegrationOverviewMixin(LitEntity) {
  render() {
    return this.renderOverview();
  }

  renderModal() {
    return html`
      <mtech-protein-integration-modal
        title="${this.title}"
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></mtech-protein-integration-modal>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.integrationEnabled = this.entity.properties.ftpCredentialsConfigured;
  }
}

window.customElements.define('mtech-protein-integration-overview', MtechProteinIntegrationOverview);
